import { Box, Chip, Typography } from "@mui/material";
import { FormatMoney } from "src/shared/Utils/FormatMoney";

import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";

import moment from "moment";
moment.locale("pt-br");

export const PlanActive = () => {
  const { userPerfil } = useAuthContext();

  if (!userPerfil?.subscription) return null;

  const objStatus = {
    ACTIVE: "ATIVO",
    TRIAL: "TESTE",
    TRIAL_EXPIRED: "TESTE EXPIRADO",
    SUSPENDED_BY_PAYMENT: "SUSPENSO POR PAGAMENTO",
    CANCELED_BY_PAYMENT: "CANCELADO POR PAGAMENTO",
    CANCELED_BY_CLIENT: "CANCELADO PELO CLIENTE",
    RENEWAL_PENDING: "RENOVAÇÃO PENDENTE",
    PENDING_PAYMENT: "PENDENTE DE PAGAMENTO",
  };

  return (
    <CardCore
      sxStyle={{
        maxWidth: "100%",
        m: 0,
        "& > *": { fontWeight: 500 },
      }}
    >
      <Box
        sx={{
          background: (theme) => theme.custom.gradient.cardSecondary,
          borderRadius: "0 24px 24px 0",
          marginLeft: { xs: "-10px", sm: "-16px" },
          marginBottom: "16px",
          padding: "6px 14px 6px 14px",
          display: "inline-block",
        }}
      >
        <Typography
          sx={{ color: "white", fontSize: { xs: "14px", sm: "16px" } }}
        >
          Assinante desde{" "}
          <strong>
            {moment(userPerfil?.subscription?.startDate).format(
              "MMMM [de] YYYY"
            )}
          </strong>
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" mb="24px">
        <Typography
          sx={{ fontSize: { xs: "16px", md: "20px" }, fontWeight: "500" }}
        >
          Plano {userPerfil?.subscription?.Plan?.title}
        </Typography>
        <Typography
          sx={{ fontSize: { xs: "12px", md: "18px" }, fontWeight: "500" }}
        >
          R$ {FormatMoney(userPerfil?.subscription?.Plan?.amount.toFixed(2))}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" mb="8px">
        <Typography>Status:</Typography>

        <Chip
          color="success"
          label={objStatus[userPerfil?.subscription?.statusSubscriptions]}
          sx={{
            fontSize: ".8rem",
            padding: ".1rem",
            height: "24px",
          }}
          variant="outlined"
        />
      </Box>

      <Box display="flex" justifyContent="space-between" mb="8px">
        <Typography>Proxima cobrança</Typography>
        {/* <Typography>DD-MM-AAAA</Typography> */}
        <Typography>..-..-....</Typography>
      </Box>
    </CardCore>
  );
};
